import React from 'react'
import { BsFacebook, BsTwitter, BsYoutube } from 'react-icons/bs'
import { AiOutlineArrowUp } from 'react-icons/ai'
import ScrollToTop from "react-scroll-to-top";

const CustomerFooter = () => {
  return (
    <div className='flex-shrink-0 bg-white w-full'>
        <ScrollToTop smooth component={<>
            <AiOutlineArrowUp className="text-3xl text-primary mx-auto"/>
        </>}/>
        <div className="flex items-center justify-between py-4 w-11/12 mx-auto max-w-[1600px]">
            <p className="text-lg font-bold">
                &copy;Idealign 2023
            </p>

            <div className="flex items-center space-x-5">
                <a href="#">
                    <BsFacebook className='text-2xl text-[#3b5998]'/>
                </a>
                <a href="#">
                    <BsTwitter className='text-2xl text-[#00acee]'/>
                </a>
                <a href="#">
                    <BsYoutube className='text-2xl text-red-500'/>
                </a>
            </div>
        </div>
    </div>
  )
}

export default CustomerFooter